import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-collapse@1.11.7@rc-collapse/es/index.js
// module id = 605
// module chunks = 0